import React from "react";
import "../Assets/Styles/SliderSection.css";
import History from "../Components/History/History";
import { Col, Container, Row } from "reactstrap";
import { useRef, useState } from "react";
import Culture from "./Culture/Culture";
import Testimonials from "./Testimonials/Testimonials";
import { useAnimateOnScroll } from "../Hooks/useAnimationScroll";
import { useTranslation } from "../Hooks/useTranslation"; // Import the hook

const componentMap = {
  AM: <History />,
  Culture: <Culture />,
  Testimonials: <Testimonials />,
};

const Credentials = () => {
  const translations = useTranslation(); // Get translations dynamically
  useAnimateOnScroll();

  const [change, setChange] = useState("AM");
  // Reference to the scroll target section
  const scrollToRef = useRef(null);

  // Scroll handler
  const scrollToContent = () => {
    scrollToRef.current.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div
      id="About-Us"
      className={`supeior-rating lg:min-h-screen flex items-center bg-[#F7F6F2] lg:bg-[#FAFAFA] py-12 lg:py-12 md:py-[8rem] ${
        change === "AM" ? "history-bg" : ""
      }`}
    >
      <Container>
        <div className="">
          <div className="mt-0 animate__animated  animate__fadeInLeft  lg:pl-0 pl-4">
            <h3 className="text-[24px] leading-[28px] md:text-[40px] max-w-[449px] md:leading-[2.8rem]  font-semibold lg:mb-6 tracking-tight extra-title-heading ">
              {translations.ourCredentialHeading}
            </h3>
            {/* <h3 className="lg:text-[2.5rem] lg:leading-[2.8rem] text-[1.5rem] leading-[1.75rem]  font-semibold lg:mb-6 tracking-tight block md:hidden">
              Our Fidelity is build of
            </h3> */}

            <div className="active-section flex lg:justify-center justify-space-between gap-2 bg-white rounded-full mt-4 mb-4 mr-4 md:max-w-[266px]">
              <button
                onClick={() => setChange("AM")}
                className={`extra-btn-font flex-1 content text-[14px] ${
                  change === "AM" ? "active bg-[#FFE9B1] font-semibold" : ""
                } font-medium  ${
                  change === "AM" ? "text-black" : "text-black"
                } py-3 px-4 rounded-full md:w-1/3`}
              >
                {translations.historyTab}
              </button>
              <button
                onClick={() => setChange("Culture")}
                className={`extra-btn-font flex-1 content text-[14px] ${
                  change === "Culture"
                    ? "active bg-[#FFE9B1] font-semibold"
                    : ""
                } font-medium  ${
                  change === "Culture" ? "text-black" : "text-black"
                } py-3 px-4 rounded-full md:w-1/3`}
              >
                {translations.cultureTab}
              </button>
              {/* <button
                onClick={() => setChange("Testimonials")}
                className={`flex-1 content text-[14px] ${
                  change === "Testimonials"
                    ? "active bg-[#FFE9B1] font-semibold"
                    : ""
                } font-medium  ${
                  change === "Testimonials" ? "text-black" : "text-black"
                } py-3 px-4 rounded-full md:w-1/3 block md:hidden`}
              >
                Testimonials
              </button> */}
            </div>
          </div>
          {componentMap[change] || null}
        </div>
      </Container>
    </div>
  );
};

export default Credentials;
